var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logos"},[_c('logo',{attrs:{"logo":_vm.logo.sngg,"inputStyle":{width:'8.24vw'}}}),_c('split_bar',{attrs:{"inputStyle":_vm.splitStyle}}),_c('logo',{attrs:{"logo":_vm.logo.kdsj,"inputStyle":{width:'8.0vw'}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }